import type { MouseEventHandler, ReactNode } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Icon } from "../Icon";

interface FilterButtonV2Props {
  children: ReactNode;
  className?: string;
  hasValue?: boolean;
  isFocused?: boolean;
  onClear?: MouseEventHandler<HTMLButtonElement>;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  shouldShowClearButton?: boolean;
}

export const FilterButtonV2 = ({
  children,
  hasValue = false,
  isFocused = false,
  onClear,
  onClick,
  shouldShowClearButton = true,
  className,
}: FilterButtonV2Props) => (
  <div
    className={classNames(
      "hover:bg-secondary bg-primary focus-within:border-secondary group relative flex h-8 items-center rounded-3xl border px-[18px] py-1.5 text-xs transition-colors",
      isFocused ? "text-dark border-light" : "text-default",
      hasValue && "border-darkest",
      className,
    )}
  >
    <button
      type="button"
      className="flex-1 text-left outline-none disabled:cursor-default"
      onClick={onClick}
      disabled={hasValue}
    >
      {children}
    </button>
    {hasValue && shouldShowClearButton && onClear && (
      <button
        type="button"
        className="bg-primary absolute right-1 top-1/2 hidden size-6 -translate-y-1/2 items-center justify-center rounded-3xl shadow-sm transition-all hover:shadow-md hover:outline hover:outline-1 group-hover:flex"
        onClick={onClear}
        data-testid="clear-filter-button"
      >
        <Icon
          type="14-close"
          useWithStrokeCurrentColor
          size={14}
          className="!w-3.5"
        />
      </button>
    )}
  </div>
);
